import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { fetchItems } from "../../../../redux/actions/repositoryActions";
import { connect } from "react-redux";
import AdminPageLayout from "../../../../components/FullPageLayout/AdminPageLayout";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import { push } from "connected-react-router";
import { useTranslation } from "react-i18next";
import Table from "../../../../components/Table/Table";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import { PropTypes } from "prop-types";
import { buildManageRepositoryItemRoute } from "../../../../routes/AdminRoutes";
import { makeGetEntities } from "../../../../redux/selectors/selectors";

const filesTableColumns = [
  {
    title: "Course Title",
    field: "title",
    options: {
      sorting: true
    },
    cellStyle: {
      minWidth: 200
    }
  },
  {
    title: "Owner",
    field: "owner",
    options: {
      sorting: true
    },
    cellStyle: {
      width: 200
    }
  },
  {
    title: "TrainingObjectID",
    field: "trainingObjectId",
    options: {
      sorting: true
    },
    cellStyle: {
      width: 200
    }
  },
  {
    title: "Status",
    field: "status",
    options: {
      sorting: true
    },
    cellStyle: {
      width: 200,
      minWidth: 200
    }
  }
];

function AssociatedFiles({
  repositoryItem,
  fetchItems,
  push,
  match: {
    params: { itemId, repositoryId }
  }
}) {
  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    fetchItems(itemId, {
      include: "associatedItems.associatedCourses"
    });
  }, []);

  useEffect(() => {
    if (
      repositoryItem &&
      repositoryItem.associatedItems &&
      repositoryItem.associatedItems.length > 0
    ) {
      const tableRows = repositoryItem.associatedItems.map(
        ({ owner, status, associatedCourses }) => {
          const title = associatedCourses
            .map(course => course.title)
            .join(", ");
          const trainingObjectId = associatedCourses
            .map(course => course.trainingObjectId)
            .join(", ");
          return {
            owner,
            status,
            title,
            trainingObjectId
          };
        }
      );

      setRowData(tableRows);
    }
  }, [repositoryItem]);

  const handleBackToManageItemView = () => {
    push(buildManageRepositoryItemRoute(repositoryId, itemId));
  };

  const { t } = useTranslation();

  return repositoryItem ? (
    <AdminPageLayout
      title={
        <Breadcrumb
          routes={[
            repositoryItem.name,
            t("manageRepository.manageItemAssociatedFiles")
          ]}
        />
      }
      onGoBackClick={handleBackToManageItemView}
    >
      <Table
        columns={filesTableColumns}
        filtering={false}
        hidePagination={true}
        data={rowData}
        onSort={() => {}}
      />
    </AdminPageLayout>
  ) : (
    <LoadingSpinner />
  );
}
const makeMapStateToProps = () => {
  const mapStateToProps = (state, props) => {
    const selector = makeGetEntities();
    const repositoryItem = selector(state.repositoryState, {
      type: "items",
      id: props.match.params.itemId
    });
    return {
      repositoryItem
    };
  };
  return mapStateToProps;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchItems, push }, dispatch);
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(AssociatedFiles);

AssociatedFiles.propTypes = {
  /**
   * The repository item that has the associated courses that are displayed
   */
  repositoryItem: PropTypes.object,
  push: PropTypes.func,
  fetchRepositories: PropTypes.func
};
